import { components, MultiValueRemoveProps } from 'react-select';
import { Close16 } from 'ui/icons/action/Close16';
import { colors } from 'ui/theme/colors';

export const MultiSelectMultiValueRemove = (props: MultiValueRemoveProps) => {
  return (
    <components.MultiValueRemove {...props}>
      <Close16 height={12} width={12} color={colors.iconPrimary} />
    </components.MultiValueRemove>
  );
};
